import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function DevOpsRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month DevOps Career Roadmap`}
      subtitle="DevOps Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-devops-roadmap.pdf"
      roleKey={roleKey || "devops"}
    />
  );
}

